<template>
	<div v-if="groupData" class="pt-3">
		<div class="row">
			<div class="col-lg-6">
				<h5>Search and Add Users</h5>
				<br />
				<div @clickaway="exitUsers" class="col-lg-6">
					<label>Select a user to add them to the group</label>
					<div class="input-and-submit-wrapper form-group">
						<div class="form-icon">
							<i class="fas fa-search"></i>
						</div>
						<input
							type="text"
							:disabled="isProcessing"
							class="has-icon form-control"
							v-model="searchUsersFilter"
							placeholder="Type User's Name"
							@input="showFilteredUsers"
						/>
					</div>
					<div
						class="dropdown-content manage-groups-scrollable-filter-results vertical-scroll"
						v-show="usersShown"
					>
						<div
							v-for="user in filteredUsers"
							:key="user.id"
							@click.prevent="selectUser(user)"
							class="dropdown-item"
						>
							{{ user.id + ' - ' + user.name }}
						</div>
					</div>
				</div>
				<br />
			</div>
			<div class="col-lg-6">
				<h5>Current Group Members</h5>
				<br />
				<ul class="list-group pt-4">
					<li
						class="list-group-item list-group-item-secondary d-flex justify-content-between align-items-center"
					>
						<div class="col-5">
							<strong>User ID - Name (Email)</strong>
						</div>
						<div class="col-2">
							<strong>Role</strong>
						</div>
						<div class="col-3">
							<strong>Remove From Teams</strong>
						</div>
						<div class="col-3">
							<strong>Actions</strong>
						</div>
					</li>
					<li
						v-for="user in groupData.groupUsers"
						:key="user.id"
						class="list-group-item d-flex justify-content-between align-items-center"
					>
						<div class="col-5">
							<span class="text-truncate d-block">
								{{ user.user_id }} - <strong>{{ user.user_name }}</strong> ({{
									user.user_email
								}})
							</span>
						</div>
						<div class="col-2">
							<span>{{ formatRole(user.role) }}</span>
						</div>
						<div class="col-3">
							<div class="custom-control custom-switch">
								<input
									class="custom-control-input"
									type="checkbox"
									:id="'removeAlsoTeams-' + user.id"
									v-model="user.removeAlsoTeams"
									style="min-height: 0"
								/>
								<label
									class="custom-control-label"
									:for="'removeAlsoTeams-' + user.id"
								></label>
							</div>
						</div>
						<div class="col-3">
							<div class="dropdown show">
								<a
									href="#"
									class="d-block d-md-flex text-center settings-link dropdown-toggle align-items-center"
									role="button"
									id="'dropdownMenuLink-' + user.id"
									data-toggle="dropdown"
									aria-haspopup="true"
									aria-expanded="false"
								>
									<i class="fa fa-cog brand-primary-gradient mr-2"></i>
									Manage
								</a>
								<div
									class="dropdown-menu"
									:aria-labelledby="'dropdownMenuLink-' + user.id"
								>
									<a
										href="#"
										@click.prevent="changeUserRole(user.id)"
										class="dropdown-item"
									>
										<i class="fa fa-user mr-2"></i>
										Turn into
										{{ user.role == 'group_member' ? 'Owner' : 'Member' }}
									</a>
									<a
										href="#"
										@click.prevent="
											deleteGroupUser(user.user_id, user.removeAlsoTeams)
										"
										class="dropdown-item"
									>
										<i class="fa fa-minus-square mr-2"></i>
										Remove from Group
									</a>
								</div>
							</div>
						</div>
					</li>
				</ul>
			</div>
		</div>
	</div>
	<div v-else>
		<div class="loader d-block text-center">
			<p><i class="fas fa-circle-notch fa-spin"></i></p>
			<p>Loading..</p>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		groupData: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			searchUsersFilter: '',
			usersShown: false,
			isProcessing: false,
			hovered: null,
			groupId: this.groupData.groupInfo.id,
		};
	},
	computed: {
		filteredUsers() {
			return this.groupData.usersToAdd.filter((user) =>
				user.name.toLowerCase().includes(this.searchUsersFilter.toLowerCase()),
			);
		},
	},
	methods: {
		formatRole(role) {
			return role === 'group_member' ? 'Member' : 'Owner';
		},
		addUserToGroup(userId) {
			const data = {
				userId: userId,
				role: 'group_member',
			};
			axios
				.post(`/api/groups/${this.groupId}/user`, data)
				.then((response) => {
					swal('Added!', 'User has been successfully added to the group.', 'success');
					this.$emit('update-triggered', true);
				})
				.catch((error) => {
					console.error(
						'There was an error adding the user to the group',
						error.response,
					);
					swal('Failed!', 'There was an error adding the user to the group.', 'error');
				});
		},
		deleteGroupUser(userId, removeAlsoFromTeams) {
			const groupId = this.groupData.groupInfo.id;
			axios
				.delete(`/api/groups/${this.groupId}/user`, {
					params: { userId, removeAlsoFromTeams },
				})
				.then((response) => {
					swal(
						'Removed!',
						'User has been successfully removed from the group.',
						'success',
					);
					this.$emit('update-triggered', true);
				})
				.catch((error) => {
					console.error('There was an error removing the user from the group', error);
					swal(
						'Failed!',
						'There was an error removing the user from the group.',
						'error',
					);
				});
		},
		changeUserRole(userId) {
			const groupId = this.groupData.groupInfo.id;
			axios
				.put(`/api/groups/${this.groupId}/change-role`, { group_user_id: userId })
				.then((response) => {
					swal('Updated!', 'User role has been successfully updated.', 'success');
					this.$emit('update-triggered', true);
				})
				.catch((error) => {
					console.error('There was an error updating the user role', error.response);
					swal('Failed!', 'There was an error updating the user role.', 'error');
				});
		},
		showFilteredUsers() {
			this.usersShown = true;
		},
		selectUser(user) {
			this.groupData.groupUsers.push(user);
			this.searchUsersFilter = '';
			this.usersShown = false;
			this.addUserToGroup(user.id);
		},
		exitUsers() {
			this.usersShown = false;
		},
	},
};
</script>
